import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords = '',
  canonicalUrl,
  ogImage = '/logo512.png'
}) => {
  useEffect(() => {
    // Update title
    document.title = `${title} | Developer Tools`;

    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    // Update description
    updateMetaTag('description', description);

    // Update keywords if provided
    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Update Open Graph tags
    updateMetaTag('og:title', `${title} | Developer Tools`, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', ogImage, true);

    if (canonicalUrl) {
      updateMetaTag('og:url', canonicalUrl, true);

      // Update canonical link
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', canonicalUrl);
    }

    // Update Twitter tags
    updateMetaTag('twitter:title', `${title} | Developer Tools`, true);
    updateMetaTag('twitter:description', description, true);
    updateMetaTag('twitter:image', ogImage, true);

    if (canonicalUrl) {
      updateMetaTag('twitter:url', canonicalUrl, true);
    }
  }, [title, description, keywords, canonicalUrl, ogImage]);

  return null;
};

export default SEO;
